import { CR_SUBMISSION } from '../constants';
import { SubmitButtonClickHandler } from './submit-button-click-handler';
import { FormWidget } from '../form-widget';

export type InitSubmitButtonParams = {
    rootElement: Pick<HTMLElement, 'querySelector' | 'querySelectorAll' | 'dataset'>;
    formWidgets: FormWidget[];
};
export const initSubmitButton = ({ rootElement, formWidgets }: InitSubmitButtonParams) => {
    const submitButton = rootElement.querySelector<HTMLButtonElement>(CR_SUBMISSION.SUBMIT.BUTTON_SELECTOR);
    if (submitButton === null) return;

    const submitButtonClickHandler = SubmitButtonClickHandler({ rootElement, formWidgets });
    submitButton.addEventListener('click', submitButtonClickHandler);
};
